import { useParams, useNavigate } from "react-router-dom";
import { Printer, ArrowLeft, GraduationCap, SealCheck } from "@phosphor-icons/react";
import { useApi, inr, fmtDate } from "../lib/api";
import { Loader } from "../components/kit";
import { SchoolMark } from "../components/Photo";

export default function Receipt() {
  const { id } = useParams();
  const nav = useNavigate();
  const { data, loading, error } = useApi(`/fees/payments/${id}`);
  return (
    <div className="min-h-screen bg-[#05050a] py-10 px-4 print:bg-white print:p-0">
      <div className="no-print mx-auto mb-6 flex max-w-2xl justify-between">
        <button className="btn-ghost" onClick={() => nav(-1)} data-testid="receipt-back-btn"><ArrowLeft size={16} /> Back</button>
        <button className="btn-primary" onClick={() => window.print()} data-testid="receipt-print-btn"><Printer size={16} /> Print / Save PDF</button>
      </div>
      {loading ? <Loader /> : error ? <p className="text-center text-rose-300" data-testid="receipt-error">{error}</p> : (
        <div className="mx-auto max-w-2xl rounded-3xl bg-white text-zinc-900 p-8 sm:p-12 shadow-2xl print:shadow-none print:rounded-none" data-testid="receipt-document">
          <div className="flex items-start justify-between gap-6 border-b border-zinc-200 pb-6">
            <div className="flex items-center gap-3">
              <SchoolMark school={data.school} className="h-14 w-14" testid="receipt-school-logo" fallback={data.school.logo_url ? <img src={data.school.logo_url} alt="" className="h-12 w-12 rounded-xl object-cover" /> :
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-gradient-to-br from-blue-500 to-orange-500 text-white"><GraduationCap size={24} weight="fill" /></span>} />
              <div>
                <div className="font-display text-xl font-bold">{data.school.name}</div>
                <div className="text-xs text-zinc-500">{[data.school.address, data.school.city].filter(Boolean).join(", ")}</div>
                <div className="text-xs text-zinc-500">{data.school.phone} · {data.school.email}</div>
              </div>
            </div>
            <div className="text-right">
              <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">Fee receipt</div>
              <div className="font-mono text-sm font-semibold" data-testid="receipt-number">{data.payment.receipt_no}</div>
              <div className="text-xs text-zinc-500">{fmtDate(data.payment.paid_at)}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 py-6 text-sm">
            {[["Student", data.student.name], ["Admission no", data.student.admission_no], ["Class", data.student.class_name], ["Parent", data.student.parent_name]].map(([k, v]) => (
              <div key={k}><div className="text-[11px] uppercase tracking-[0.16em] text-zinc-500">{k}</div><div className="font-semibold">{v || "—"}</div></div>
            ))}
          </div>
          <table className="w-full text-sm">
            <thead><tr className="border-y border-zinc-200 text-left text-[11px] uppercase tracking-[0.16em] text-zinc-500"><th className="py-2">Description</th><th className="py-2 text-right">Amount</th></tr></thead>
            <tbody>
              <tr><td className="py-3">{data.payment.title}</td><td className="py-3 text-right">{inr(data.payment.amount)}</td></tr>
            </tbody>
            <tfoot><tr className="border-t border-zinc-200"><td className="py-3 font-bold">Total paid</td><td className="py-3 text-right font-display text-xl font-bold" data-testid="receipt-amount">{inr(data.payment.amount)}</td></tr></tfoot>
          </table>
          <div className="mt-4 grid grid-cols-2 gap-4 text-xs text-zinc-600">
            <div>Payment mode: <span className="font-semibold capitalize">{data.payment.method.replace("_", " ")}</span></div>
            {data.payment.razorpay_payment_id && <div>Transaction: <span className="font-mono">{data.payment.razorpay_payment_id}</span></div>}
            <div>Invoice total: {inr(data.invoice.amount)} · Balance: {inr((data.invoice.amount || 0) - (data.invoice.paid_amount || 0))}</div>
          </div>
          <div className="mt-10 flex items-center justify-between border-t border-zinc-200 pt-6">
            <span className="inline-flex items-center gap-2 text-emerald-600 text-sm font-semibold"><SealCheck size={20} weight="fill" /> Payment received</span>
            <span className="text-[11px] text-zinc-400">Computer-generated receipt · Schola-AI</span>
          </div>
        </div>
      )}
    </div>
  );
}
